import { Alert, Box, Link, Text } from '@nimbus-ds/components';

interface ExternalInvoiceSectionProps {
  readonly title: string;
  readonly errorTitle?: string;
  readonly fileUrl?: string;
  readonly errorMessage?: string[];
  readonly t: any;
}

function ExternalInvoiceSection({
  title,
  errorTitle,
  fileUrl,
  errorMessage,
  t,
}: ExternalInvoiceSectionProps) {
  return (
    <Box>
      <Box display="flex" alignItems="center" gap="2">
        <Text color="neutral-textHigh">{title}</Text>
        {!!fileUrl && (
          <Link
            as="a"
            href={fileUrl}
            target="_blank"
            appearance="primary"
            textDecoration="none"
          >
            {t('cardInvoice.externalInvoice.view')}
          </Link>
        )}
      </Box>

      {!!errorMessage && errorMessage.length > 0 && (
        <Alert title={errorTitle} appearance="danger" show>
          <Box>
            {errorMessage.map((msg, i) => (
              <Text
                key={`${msg.slice(0, 10)}-${i}`}
                fontSize="base"
                fontWeight="regular"
              >
                {msg}
              </Text>
            ))}
          </Box>
        </Alert>
      )}
    </Box>
  );
}

export default ExternalInvoiceSection;
